import { css } from "@emotion/css"

import Circle from "../components/shape/Circle"

const CircleHeader = ({ color, children }: { color: string; children: string }) => {
  return (
    <div className={styles.header}>
      <Circle size={16} color={color} />
      <h4>{children}</h4>
    </div>
  )
}

export default CircleHeader

const styles = {
  header: css`
    display: flex;
    align-items: center;
    > h4 {
      padding-bottom: 3px;
      padding-left: 3px;
      font-size: 16px;
      font-weight: bold;
      line-height: 16px;
      color: #4d4d4d;
    }
  `,
}
